import { api } from "./axios";

export const submitContactMessage = async (payload) => {
  return api.post("/contact-messages", payload);
};

export const getContactMessages = () => {
  return api.get("/contact-messages");
};

export const markContactMessageAsRead = (id) => {
  return api.put(`/contact-messages/${id}/read`);
};

export const deleteContactMessage = (id) => {
  return api.delete(`/contact-messages/${id}`);
};
